import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { withCookies } from "react-cookie";
import { withRouter } from "react-router-dom";
import Select from "react-select";
import ReactQuill from "react-quill";
import WorkTime from "./_workTime";
import { Request } from "../../BackendClient";
import ApiClient from "../../Client";
import "react-quill/dist/quill.snow.css";

const { REACT_APP_CDN_HOST: CDN_HOST } = process.env;

const mapStateToProps = ({ identity }) => ({
  identity
});

const weekDays = [
  "Понедельник",
  "Вторник",
  "Среда",
  "Четверг",
  "Пятница",
  "Суббота",
  "Воскресенье"
];

class TheatreForm extends Component {
  state = {
    isFetching: false,
    errors: {},
    uploadError: ""
  };

  componentWillUnmount() {
    this.isCancelled = true;
  }

  getAuthKey() {
    const { cookies } = this.props;
    return cookies.get(process.env.REACT_APP_IDENTITY_COOKIE) || "";
  }

  findOptionByValue(list, value) {
    if (list && value) {
      for (let idx = 0; idx < list.length; idx++) {
        if (list[idx].value === value) {
          return list[idx];
        }
      }
    }
    return null;
  }

  componentDidMount = () => {
    const {
      identity: { theatreId }
    } = this.props;
    const { isFetching } = this.state;
    if (theatreId && !isFetching) {
      !this.isCancelled && this.setState({ isFetching: true });
      const authKey = this.getAuthKey();
      !this.isCancelled &&
        Promise.all([
          this.fetchTheatre(authKey, theatreId).then(theatre => {
            if (!theatre) {
              return this.props.history.replace("/page-not-found");
            }
            const { city, workMode, ...data } = theatre;
            const { id: workModeId, workTime } = workMode || {
              id: null,
              workTime: []
            };

            return {
              ...data,
              cityId: (city && city.id) || null,
              workModeId,
              workTime
            };
          }),
          this.fetchCities(authKey)
        ])
          .then(res =>
            res.reduce((prev, result) => Object.assign(prev, result), {})
          )
          .then(
            state =>
              !this.isCancelled &&
              this.setState({ isFetching: false, ...state })
          );
    }
  };

  fetchTheatre(authKey, id) {
    return ApiClient.setHeader("authKey", authKey)
      .request(
        "query($id:ID!){theatre(where:{id:$id}){id name site address phone about image city{id} workMode{id workTime}}}",
        { id }
      )
      .then(({ theatre }) => theatre);
  }

  fetchCities(authKey) {
    return ApiClient.setHeader("authKey", authKey)
      .request(`{cities{id name value:id label:name}}`)
      .then(({ cities }) => ({ cities }));
  }

  submit = () => {
    if (this.validate()) {
      const {
        id,
        name,
        site,
        address,
        email,
        phone,
        about,
        image,
        cityId,
        workModeId,
        workTime
      } = this.state;
      const data = {
        name,
        site,
        address,
        email,
        phone,
        about,
        image,
        city: { connect: { id: cityId } },
        workMode: {
          [workModeId ? "update" : "create"]: { workTime }
        }
      };
      !this.isCancelled &&
        ApiClient.setHeader("authKey", this.getAuthKey())
          .request(
            "mutation($id:ID! $data:TheatreUpdateInput!){updateTheatre(where:{id:$id} data:$data){id}}",
            { id, data }
          )
          .then(
            ({ updateTheatre }) =>
              !this.isCancelled &&
              updateTheatre &&
              updateTheatre.id &&
              this.props.history.goBack()
          );
    }
  };

  onChangeInput = (name, value) => {
    this.setState({ [name]: value }, () => {
      this.hasErrors(name) && this.validate(name);
    });
  };

  setError(name, message) {
    this.addErrors({ [name]: message });
  }

  getError(name) {
    return this.state.errors[name] || null;
  }

  addErrors(errors) {
    this.setState({ errors: { ...this.state.errors, ...errors } });
  }

  validate(attributes = null, refresh = true) {
    const errors = refresh ? {} : this.state.errors;
    const { name, site, cityId, email, phone } = this.state;
    if (attributes && !Array.isArray(attributes)) {
      attributes = [attributes];
    }

    if ((!attributes || attributes.includes("name")) && !name) {
      errors["name"] = "Field 'name' is required";
    }

    if ((!attributes || attributes.includes("email")) && email) {
      !/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i.test(
        String(email).toLowerCase()
      ) && (errors["email"] = "Field 'email' is invalid");
    }

    if ((!attributes || attributes.includes("phone")) && phone) {
      !/^((\+7|7|8)+([0-9]){10})$/.test(String(phone).toLowerCase()) &&
        (errors["phone"] = "Field 'phone' is invalid");
    }

    if ((!attributes || attributes.includes("site")) && site) {
      const re = new RegExp(
        "^(https://|http://|//|)?" + // protocol
        "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|" + // domain name
        "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
        "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
        "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
          "(\\#[-a-z\\d_]*)?$", // fragment locator
        "i"
      );
      !re.test(String(site).toLowerCase()) &&
        (errors["site"] = "Field 'site' is invalid");
    }

    if ((!attributes || attributes.includes("city")) && !cityId) {
      errors["city"] = "Field 'city' is required";
    }

    // if ((!attributes || attributes.includes("workTime"))) {
    // }

    !attributes
      ? this.setState({ errors })
      : this.addErrors(
          attributes.reduce(
            (prev, attribute) =>
              Object.assign(prev, { [attribute]: errors[attribute] || null }),
            {}
          )
        );
    return !Object.entries(errors).length;
  }

  hasErrors(name = null) {
    const { errors } = this.state;
    return !!(name ? errors[name] : Object.entries(errors).length);
  }

  cityInputOnChange = cityId => {
    this.setState(
      { city: cityId.value || null },
      () => this.hasErrors("city") && this.validate("city")
    );
  };

  aboutInputOnChange = about => {
    this.setState(
      { about },
      () => this.hasErrors("about") && this.validate("about")
    );
  };

  changeWorkTimeItem = (weekDay, timeIdx, time) => {
    const workTime = [...(this.state.workTime || [])];
    workTime[weekDay][timeIdx] = time;
    this.setState(
      { workTime },
      () => this.hasErrors("workTime") && this.validate("workTime")
    );
  };

  renderError(name) {
    if (this.hasErrors(name)) {
      return <span className="text-danger">{this.getError(name)}</span>;
    }
    return "";
  }

  renderInput(
    name,
    label,
    groupProps = {},
    inputProps = {},
    defaultValue = ""
  ) {
    if (!groupProps.className) {
      groupProps.className = "office-form__group";
    }
    const value = this.state[name] || defaultValue;
    const hasError = this.hasErrors(name) || null;
    if (hasError) {
      groupProps.className += " has-error";
    }
    let component = "input";
    if (inputProps.component) {
      component = inputProps.component;
      delete inputProps.component;
    }
    if (!inputProps.id) {
      inputProps.id = `${name}-input`;
    }
    if (!inputProps.onChange) {
      inputProps.onChange = e => this.onChangeInput(name, e.target.value);
    }
    return (
      <div {...groupProps}>
        <label htmlFor={inputProps.id}>{label}</label>
        {React.createElement(component, { value, ...inputProps })}
        {hasError && <span className="text-danger">{this.getError(name)}</span>}
      </div>
    );
  }

  onImageUploadClick = () => {
    this.refs.fileUploader.click();
  };

  makeCdnRequest = () => new Request({ host: CDN_HOST });

  fileUploaderHandle = e => {
    e.stopPropagation();
    e.preventDefault();
    const [file] = e.target.files;
    if (file) {
      const form = new FormData();
      form.append("image", file);
      !this.isCancelled &&
        this.makeCdnRequest()
          .setEndpoint("/image/upload")
          .setMethod("POST")
          .setBody(form)
          .fetchJson()
          .then(res => {
            if (res) {
              const { success, images } = res;
              if (success && images && images[0]) {
                const [{ name, url, ext }] = images;
                return (
                  !this.isCancelled &&
                  this.setState({
                    image: `${url}/${name}.${ext}`,
                    uploadError: ""
                  })
                );
              }
            }
            !this.isCancelled &&
              this.setState({ uploadError: "Image upload error." });
          });
    }
  };

  renderImageField() {
    const { image, uploadError } = this.state;
    const src = image ? `${CDN_HOST}/${image}` : "/images/icon-inst.png";
    return (
      <div className="office-form__avatar">
        <label>
          <input
            type="file"
            ref="fileUploader"
            style={{ display: "none" }}
            onChange={this.fileUploaderHandle}
          />
          <img
            alt="Изображение"
            ref="image"
            className="avatar-uploader"
            src={src}
            onError={() =>
              Object.assign(this.refs.image, {
                src: "/images/icon-inst.png",
                onerror: ""
              })
            }
          />
          <span className="btn btn-link text-white">Загрузить</span>
          {uploadError && (
            <Fragment>
              <br />
              <span className="text-danger">{uploadError}</span>
            </Fragment>
          )}
        </label>
      </div>
    );
  }

  render() {
    const { cities, cityId, workTime } = this.state;
    return (
      <Fragment>
        <h1 className="office-h1">Данные кинотеатра</h1>
        <div className="office-form office-form_white">
          {this.renderImageField()}
          {this.renderInput(
            "name",
            "Название",
            { className: "office-form__group required" },
            { placeholder: "Название" }
          )}
          <div className="office-form__union-3">
            {this.renderInput(
              "email",
              "Электронная почта",
              {},
              { placeholder: "Электронная почта" }
            )}
            {this.renderInput(
              "phone",
              "Контактный телефон",
              {},
              { placeholder: "Контактный телефон" }
            )}
            {this.renderInput(
              "site",
              "Адрес сайта",
              {},
              { placeholder: "Адрес сайта" }
            )}
          </div>
          <div className="office-form__union-2">
            {this.renderInput(
              "city",
              "Город",
              { className: "office-form__group required" },
              {
                component: Select,
                value: this.findOptionByValue(cities, cityId),
                onChange: this.cityInputOnChange,
                options: cities || [],
                className: "selectReact",
                classNamePrefix: "selectReact",
                placeholder: "Начните вводить название города"
              }
            )}
            {this.renderInput("address", "Адрес", {}, { placeholder: "Адрес" })}
          </div>
          {this.renderInput(
            "about",
            "О кинотеатре",
            {},
            {
              component: ReactQuill,
              onChange: this.aboutInputOnChange,
              theme: "snow"
            }
          )}
          <WorkTime
            weekDays={weekDays}
            time={workTime || []}
            onChangeItem={this.changeWorkTimeItem}
            validationError={this.getError("workTime") || ""}
          />
          <hr />
          <div>
            <button className="btn-gradient" onClick={this.submit}>
              Сохранить
            </button>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default withCookies(withRouter(connect(mapStateToProps)(TheatreForm)));



// WEBPACK FOOTER //
// ./src/containers/theatre/form.jsx